import { useMemo } from 'react';

import { useFormState } from 'react-final-form';

import { usePetitionReportAbuseContext } from '../../../../shared/context';
import type { FormValues } from '../../../../shared/types';
import { getSubSubCategoriesOrQuestions } from '../../../../shared/utils';

type Result = ModelHookResult<{
	hideSubmit: boolean;
}>;

export function useSubmitButton(): Result {
	const { type } = usePetitionReportAbuseContext();
	const {
		values: { subCategory },
	} = useFormState<FormValues>({
		subscription: { values: true },
	});

	const data = useMemo(() => {
		if (subCategory) {
			const subSubCategoriesOrQuestions = getSubSubCategoriesOrQuestions(type, subCategory);
			if (subSubCategoriesOrQuestions.type === 'question') {
				const hasLinkQuestion = subSubCategoriesOrQuestions.value.some((question) => question.type === 'link');
				return {
					hideSubmit: hasLinkQuestion,
				};
			}
		}
		return {
			hideSubmit: false,
		};
	}, [subCategory, type]);
	return { data };
}
